import { Fragment, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import { Link } from "react-router-dom";

import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { getAllBanner } from "../../reducers/adminReducers";
import Loader from "../loader/loader";
import BannerList from "./bannerList";
import NoDataFound from "../Generik/NoDataFound";

const Banner = () => {
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [loader, setLoader] = useState(false);
  const result = useSelector((state) => state.admin);
  const { bannerData } = result || {};

  const dispatch = useDispatch();

  const handleOnDelete = async (id) => {
    try {
      setOpen(false);
      setLoader(true);
      const response = await adminInstance().delete(
        `api/admin/deleteBanner/${id}`
      );
      const { code } = response.data;
      if (code === 200) {
        dispatch(getAllBanner());
        toast.success("Successfully Deleted", { toastId: 1 });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoader(true);
    dispatch(getAllBanner()).then((res) => {
      if (res) {
        setLoader(false);
      }
    });
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumb title="Banner" />
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <h5>Banner </h5>
          </CardHeader>
          <CardBody>
            <Link className="btn btn-secondary" to="/add-banner">
              Add Banner
            </Link>
            {!loader ? (
              bannerData && bannerData.length > 0 ? (
                <BannerList
                  setActiveId={setActiveId}
                  setOpen={setOpen}
                  bannerData={bannerData}
                />
              ) : (
                <NoDataFound data="Banner" />
              )
            ) : (
              <Loader />
            )}
          </CardBody>
        </Card>
      </Container>

      <DeleteConfirmPopup
        title={"Delete Category"}
        open={open}
        handleOnDelete={handleOnDelete}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};

export default Banner;
